/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Configuration } from '../models/Configuration'
import type { DeviceToken } from '../models/DeviceToken'
import type { DeviceType } from '../models/DeviceType'
import type { Employee } from '../models/Employee'
import type { EmployeeArray } from '../models/EmployeeArray'
import type { PinChange } from '../models/PinChange'
import type { TaskConfigArray } from '../models/TaskConfigArray'
import type { UserAuthToken } from '../models/UserAuthToken'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class DeviceService {
  /**
   * 📱 Get the device configuration
   * @returns any OK
   * @throws ApiError
   */
  public static getConfig(): CancelablePromise<{
    data?: Configuration
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/device/config',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Get all Employees with projects and events which are related to requesting device
   * @returns any OK
   * @throws ApiError
   */
  public static getEmployees(): CancelablePromise<{
    data?: EmployeeArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/device/employees',
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Get a single Employee
   * @param employeeId
   * @returns any OK
   * @throws ApiError
   */
  public static getEmployee(employeeId: number): CancelablePromise<{
    data?: Employee
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/device/employee/{employeeId}',
      path: {
        employeeId: employeeId,
      },
      errors: {
        401: `The request was unauthenticated`,
      },
    })
  }
  /**
   * 📱 Change PIN of single employee
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static changeEmployeePin(requestBody?: PinChange): CancelablePromise<{
    data?: {
      hashed_pin?: string | null
    }
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/device/changeEmployeePin',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Stores the push_token for the authenticated device
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static storePushToken(requestBody?: {
    push_token: string
    device_type: string
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/device/pushToken',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 📱 Get tasksConfigs for all employees
   * @returns any OK
   * @throws ApiError
   */
  public static getTaskConfigs(): CancelablePromise<{
    data?: TaskConfigArray
    meta?: Record<string, any>
    links?: Record<string, any>
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/device/taskConfigs',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
  /**
   * 🗝 Upgrade old app to new by exchanging legacy token for new and generating new Device and Config
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static upgradeAppV1AppV2(requestBody?: {
    legacy_token?: string
  }): CancelablePromise<{
    data?: {
      user_token?: UserAuthToken
      device_token: DeviceToken
      type: DeviceType
    }
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/device/upgrade/appv1/appv2',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `The request was unauthenticated`,
        422: `Request validation failed`,
      },
    })
  }
}
